import {
  REQUEST as req,
  RESPONSE as res,
  FAILURE as fail,
  CLEAR as clr,
} from '../../actions/datasources/schedule';

const initialState = {
  response: [],
  error: null
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:
      return {
        ...state,
        response: state.response.some(item => item.datasource_id === action.payload.datasource_id) 
          ? state.response.map(item => 
              item.datasource_id === action.payload.datasource_id ? { ...item, loading: true, status:action.payload.action } : item
            )
          : [...state.response, { datasource_id: action.payload.datasource_id, loading: true, status:action.payload.action }],
        error: null
      };

    case res:
      return {
        ...state,
        response: state.response.some(item => item.datasource_id === action.payload.datasource_id) 
          ? state.response.map(item => 
              item.datasource_id === action.payload.datasource_id ? { ...item, loading: false, status:action.payload.action } : item
            )
          : [...state.response, { datasource_id: action.payload.datasource_id, loading: false, status:action.payload.action }],
      };
      case clr:
        return {
          ...state,
          response: [],
          isLoading: false,
          error: null
        };    

    default:
      return state;
  }
};
